import { Command } from '@ckeditor/ckeditor5-core';
import LinkModal from '../../link-modal';
export default class InsertRelatedArticleCommand extends Command {
    execute() {
        try {
            const publications = this.editor.config.get('internalLink.publications') || [];
            const linkModal = new LinkModal(this.filterByType(publications, 'post'));
            linkModal
                .show()
                .then((articleItem) => {
                this.editor.model.change((writer) => {
                    this.editor.model.insertContent(createRelatedArticle(writer, articleItem));
                });
            })
                .catch(() => { });
        }
        catch (error) {
            console.error(error);
        }
    }
    filterByType(publications, type) {
        return publications.filter(({ linkType }) => linkType === type);
    }
    refresh() {
        this.isEnabled = true;
    }
}
function createRelatedArticle(writer, articleItem) {
    const { title, description, publicationId } = articleItem;
    const relatedArticle = writer.createElement('relatedArticle', {
        postId: publicationId,
    });
    const titleElement = writer.createElement('relatedArticleTitle');
    const descriptionElement = writer.createElement('relatedArticleDescription');
    writer.appendText(title, titleElement);
    writer.appendText(description, descriptionElement);
    writer.append(titleElement, relatedArticle);
    writer.append(descriptionElement, relatedArticle);
    return relatedArticle;
}
